export const LIBRARY_PAGE_BASE_URL = '/content-collection';

// TODO: Replace with non-test content collection URL
export const UDEMY_PRO_PLACEHOLDER_URL = `${LIBRARY_PAGE_BASE_URL}/it-certifications`;
export const HOME_URL = '/';

// DEPRECATED: PREFER SubscriptionPlanProductType in generated GraphQL code
export const UDEMY_PRO = 'UDEMYPRO';
export const CONSUMER_SUBSCRIPTION = 'CONSUMERSUBSCRIPTION';
//# sourceMappingURL=constants.js.map